import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
class Utility extends AudioEffect {
    constructor() {
        super();
        this.gainNode = new Tone.Gain(0, "decibels");
        this.gainNodeOut = new Tone.Gain(0, "decibels");
        this.input().connect(this.output());
    }
    input() { return this.gainNode; }
    output() { return this.gainNodeOut; }
    get gain() {
        return this.gainNode.gain;
    }
}
export default Utility;
//# sourceMappingURL=Utility.js.map